import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled, { css } from "styled-components";

export const WrapperCustomFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(4)};
`;

export const ContainerValuesCustom = styled.div`
  display: flex;
  align-items: center;
  gap: ${toRem(8)};
`;

export const TitleValuesCustom = styled.div<{
  isSettings: boolean | undefined;
}>`
  font-size: ${({ isSettings }) => (isSettings ? toRem(12) : toRem(16))};
  font-weight: ${({ isSettings }) => (isSettings ? 400 : 700)};
  line-height  ${({ isSettings }) => (isSettings ? toRem(16) : toRem(20))};
  color: ${COLORS.FG.DEFAULT};
  padding: ${toRem(12)};
`;

type TableEditHeaderDropDownItemProps = {
  $isActive: boolean;
  isSettings: boolean | undefined;
};

export const TableEditHeaderDropDownItem = styled.div<TableEditHeaderDropDownItemProps>`
  ${({ isSettings, $isActive }) =>
    isSettings &&
    css`
      margin: 0 ${toRem(12)};
      display: flex;
      align-items: center;
      gap: ${toRem(8)};
      padding: ${toRem(8)} ${toRem(12)};
      font-size: ${toRem(14)};
      line-height: ${20 / 14};
      cursor: pointer;
      border-radius: ${toRem(8)};
      color: ${$isActive ? COLORS.ACCENT.DEFAULT : COLORS.FG.DISABLED};

      ${$isActive &&
      css`
        background-color: ${COLORS.ACCENT.CONTAINER_SOFT};
      `}
    `}
`;
